import React, { useEffect } from 'react';
import { withRouter, useParams } from 'react-router-dom';
import { colors } from '@guryou/colors';
import FlowStepper from '../inviteFlow/FlowStepper';
import { FlexRow, Spinner } from '@guryou/html-components';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerInvitationFlow, stateIsLoading } from '@guryou/redux';
import InvalidUser from './InvalidUser';

const CustomerFlow = () => {
  const dispatch = useDispatch();

  const { customerFlowId } = useParams();
  const auth = useSelector(state => state.auth);

  const flowSelector = useSelector(state => state.customersInvitationFlow.customerInvitationFlow);

  useEffect(() => {
    if (customerFlowId) {
      dispatch(getCustomerInvitationFlow(customerFlowId));
    }
  }, [dispatch, customerFlowId]);

  if (stateIsLoading(flowSelector)) {
    return (
      <div className={`mx-auto w-full h-full p-4 sm:p-8 bg-[${colors.mineShaft}]`}>
        <Spinner />
      </div>
    );
  }

  const authUserId = +auth?.data?.userId;
  const flowUserId = +flowSelector?.data?.userId;
  const email = auth?.data?.email;

  if (authUserId !== flowUserId) {
    return <InvalidUser />;
  }

  return (
    <FlexRow xs={12} alignItems="flex-start" minHeight="100%" paddingTop="4vh" paddingBottom="4vh" backgroundColor={colors.mineShaft} margin={0}>
      <FlowStepper flowData={flowSelector.data || []} email={email} />
    </FlexRow>
  );
};

export default withRouter(CustomerFlow);
